import "./polyfills";
if (import.meta.env.DEV) {
    console.debug("[main] entry:", {
        href: window.location?.href,
        pathname: window.location?.pathname,
        userAgent: window.navigator?.userAgent,
    });
}
if (import.meta.env.DEV) {
    import("./dev").then((mod) => mod.install()).catch(() => { });
}
// Defer app bootstrap to ensure Module Federation shared scope is initialized.
import("./bootstrap");
